import {

    ASSIGN_INTERVIEW_CANDIDATE_REQUEST,
    ASSIGN_INTERVIEW_CANDIDATE_SUCCESS,
    ASSIGN_INTERVIEW_CANDIDATE_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const assignInterviewCandidateByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case ASSIGN_INTERVIEW_CANDIDATE_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case ASSIGN_INTERVIEW_CANDIDATE_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ASSIGN_INTERVIEW_CANDIDATE_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default assignInterviewCandidateByAdminReducer;